<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse" key="collapse" class="sidebar-logo-link sidebar-logo-link--collapse"
        to="/"
      >
        <img
          v-if="smallLogo" :src="smallLogo" class="sidebar-logo sidebar-logo--mark"
          alt="安骏"
        >
      </router-link>
      <router-link
        v-else key="expand" class="sidebar-logo-link sidebar-logo-link--expand"
        to="/"
      >
        <img
          v-if="largeLogo" :src="largeLogo" class="sidebar-logo sidebar-logo--brand"
          alt="安骏快递"
        >
      </router-link>
    </transition>
  </div>
</template>

<script>
const largeLogoSrc = require('@/assets/anjunTxt.jpg');
const smallLogoSrc = require('@/assets/ajlogo1.svg');
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      // logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
      largeLogo: largeLogoSrc,
      smallLogo: smallLogoSrc
    };
  }
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  padding: 2px 18px;
  background: #ffffff;
  border-bottom: 1px solid #e5e6eb;
  text-align: center;
  overflow: hidden;
  box-sizing: border-box;

  & .sidebar-logo-link {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    height: 100%;
    overflow: hidden;
    min-width: 0;

    &.sidebar-logo-link--expand {
      justify-content: center;
    }

    &.sidebar-logo-link--collapse {
      justify-content: center;
    }

    & .sidebar-logo {
      display: block;
      object-fit: contain;
      flex: none;
    }

    & .sidebar-logo--brand {
      width: auto;
      max-width: 100%;
      height: 56px;
    }

    & .sidebar-logo--mark {
      width: 52px;
      max-width: 100%;
      height: auto;
    }
  }

  &.collapse {
    padding: 8px 8px;

    .sidebar-logo-link {
      justify-content: center;
    }
  }
}
</style>

<style lang="scss">
.sidebar-logo-container .sidebar-logo-link {
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  min-width: 0;
  white-space: nowrap;
}

.sidebar-logo-container .sidebar-logo-link--expand {
  flex-direction: row !important;
  justify-content: center !important;
}

.sidebar-logo-container .sidebar-logo {
  display: block;
  flex: 0 0 auto;
}
</style>
